import React, {Component} from "react";
import ControlPanel from "./ControlPanelView";
import {ControlPanelService} from "../../service/controlPanel/ControlPanelService";
import {getContextMenu, getUrlControlPanel, validateContinue} from "./util/ControlPanelUtil";
import ConfirmationMessage from "../../components/confirmationMessage";
import {amount, numberWithComma, price, rateMultipliedByOneHundred} from "../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import {CONTROL_PANEL_ROUTE} from "../../utils/constants/RoutesConstants";
import {EXTERNO, INTERNO} from "../../utils/constants/Constants";
import ContextMenu from "../../components/contextMenu";

export default class ControlPanelContainer extends Component {
    refreshTimeoutId;

    constructor(props) {
        super(props);

        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.loadingControlPanel = this.loadingControlPanel.bind(this);
        this.controlPanelTemplate = this.controlPanelTemplate.bind(this);
        this.getControlPanelLoan = this.getControlPanelLoan.bind(this);
        this.selectRowControlPanel = this.selectRowControlPanel.bind(this);
        this.onRowDoubleClickControlPanel = this.onRowDoubleClickControlPanel.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.anticipatedMaturity = this.anticipatedMaturity.bind(this);
        this.boldAndColor = this.boldAndColor.bind(this);
        this.boldAndColorTextTemplate = this.boldAndColorTextTemplate.bind(this);
        this.boldAndColorAmountTemplate = this.boldAndColorAmountTemplate.bind(this);
        this.boldAndColorPriceTemplate = this.boldAndColorPriceTemplate.bind(this);
        this.boldAndColorNumberTemplate = this.boldAndColorNumberTemplate.bind(this);
        this.boldAndColorRateTemplate = this.boldAndColorRateTemplate.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.startTimeRefreshControlPanel = this.startTimeRefreshControlPanel.bind(this);
        this.stopTimeRefreshControlPanel = this.stopTimeRefreshControlPanel.bind(this);

        this.saveToLocal = this.saveToLocal.bind(this);

        this.today = new Date();

        let maturityDateLocalStorage = new Date(Date.parse(localStorage.getItem('maturityDate')));
        let concertDateLocalStorage = new Date(Date.parse(localStorage.getItem('concertDate')));

        this.state = {
            isLoading: true,
            isLoadingControlPanel: false,
            totalExpiredLoad: 0,
            isAdminUser: localStorage.getItem("institution") === "Interno",
            options: [],
            exportOptions: [],
            loanControlPanel: [],
            selectedControlPanel: '',
            loanIdFilter: localStorage.getItem('loanIdFilter') !== null ? localStorage.getItem('loanIdFilter') : '',
            catFlowFilter: localStorage.getItem('catFlowFilter') !== null ? JSON.parse(localStorage.getItem('catFlowFilter')) : [],
            catInstitutionLenderFilter: localStorage.getItem('catInstitutionLenderFilter') !== null ? JSON.parse(localStorage.getItem('catInstitutionLenderFilter')) : [],
            catInstitutionBorrowerFilter: localStorage.getItem('catInstitutionBorrowerFilter') !== null ? JSON.parse(localStorage.getItem('catInstitutionBorrowerFilter')) : [],
            catRentTypeFilter: localStorage.getItem('catRentTypeFilter') !== null ? JSON.parse(localStorage.getItem('catRentTypeFilter')) : [],
            maturityDate: localStorage.getItem('maturityDate') !== null && localStorage.getItem('maturityDate') !== ''
                ? new Date(
                    maturityDateLocalStorage.getFullYear(),
                    maturityDateLocalStorage.getMonth(),
                    maturityDateLocalStorage.getDate()
                )
                : '',
            concertDate: localStorage.getItem('concertDate') !== null && localStorage.getItem('concertDate') !== ''
                ? new Date(
                    concertDateLocalStorage.getFullYear(),
                    concertDateLocalStorage.getMonth(),
                    concertDateLocalStorage.getDate()
                )
                : '',
            today: this.today,

            exportOptionsVig: [
                {
                    label: "Excel", action: () => {
                        this.handleCurrentContextMenu("XLS")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.handleCurrentContextMenu("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.handleCurrentContextMenu("CSV")
                    }
                },
            ],

            exportOptionsVen: [
                {
                    label: "Excel", action: () => {
                        this.handleMaturityContextMenu("XLS")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.handleMaturityContextMenu("PDF")
                    }
                },
                {
                    label: "CSV", action: () => {
                        this.handleMaturityContextMenu("CSV")
                    }
                },
            ],
            disabledSearchButton: true,
        };

        this.controlPanelTable = React.createRef();

        this.getControlPanelLoan();
    };

    startTimeRefreshControlPanel() {
        this.refreshTimeoutId = setInterval(this.getControlPanelLoan, 10000);
    }

    stopTimeRefreshControlPanel() {
        clearInterval(this.refreshTimeoutId);
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    loadingControlPanel(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoadingControlPanel: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        this.startTimeRefreshControlPanel();
    }

    componentWillUnmount() {
        this.stopTimeRefreshControlPanel();
    }

    saveToLocal() {
        const loanIdFilter = this.state.loanIdFilter;
        const catInstitutionLenderFilter = this.state.catInstitutionLenderFilter;
        const catInstitutionBorrowerFilter = this.state.catInstitutionBorrowerFilter;
        const catRentTypeFilter = this.state.catRentTypeFilter;
        const catFlowFilter = this.state.catFlowFilter;
        const maturityDate = this.state.maturityDate;
        const concertDate = this.state.concertDate;

        localStorage.setItem('loanIdFilter', loanIdFilter);
        localStorage.setItem('catInstitutionLenderFilter', JSON.stringify(catInstitutionLenderFilter));
        localStorage.setItem('catInstitutionBorrowerFilter', JSON.stringify(catInstitutionBorrowerFilter));
        localStorage.setItem('catRentTypeFilter', JSON.stringify(catRentTypeFilter));
        localStorage.setItem('catFlowFilter', JSON.stringify(catFlowFilter));
        localStorage.setItem('maturityDate', maturityDate);
        localStorage.setItem('concertDate', concertDate);
    }

    saveFilters(event) {
        const {name, value} = event.target;
        this.setState({
                [name]: value,
            },
            this.saveToLocal
        );
    }

    selectRowControlPanel(event) {
        this.setState({
            selectedControlPanel: event.value,
        });
    }

    onRowDoubleClickControlPanel(event) {
        this.handleControlPanelContextMenu(event, 'Continuar');
    }

    handleCurrentContextMenu(option) {
        this.controlPanelService.getReportCurrentLoanControlPanel(option,
            localStorage.getItem('institution') === 'Interno' ? INTERNO : EXTERNO)
            .then(response => {
                this.setState({
                    isLoading: false
                });
            });
    }

    handleMaturityContextMenu(option) {
        this.controlPanelService.getReportMaturityControlPanel(option)
            .then(response => {
                this.setState({
                    isLoading: false
                });
            });
    }

    handleControlPanelContextMenu(event, option) {
        if (option === 'Vencimiento Anticipado') {
            if (this.state.selectedControlPanel) {
                this.setState({
                    anticipatedMaturity: this.state.selectedControlPanel.idFolioPrest,
                });
                if (this.confirmationRef) {
                    this.confirmationRef.openConfirmationMessage()
                }
            }
        } else {
            let url = getUrlControlPanel(option, this.state.selectedControlPanel);

            if (url !== '') {
                this.props.history.push({
                    pathname: url,
                    state: {
                        isAdmin: false,
                        returnPath: CONTROL_PANEL_ROUTE,
                        selectedLoanControlPanel: this.state.selectedControlPanel,
                        folio: this.state.selectedControlPanel.idFolioPrest,
                        loanId: this.state.selectedControlPanel.idFolioPrest,
                        flowId: this.state.selectedControlPanel.idFlujo,
                        seleccionGaran: this.state.selectedControlPanel.seleccionGaran,
                        loanAmount: this.state.selectedControlPanel.importe,
                        loanAmount24Hrs: this.state.selectedControlPanel.importe24Hrs,
                        maturity: this.state.selectedControlPanel.plazo,
                        borrowerAccount: this.state.selectedControlPanel.cuentaPTT,
                        status: this.state.selectedControlPanel.statusPV,
                    },
                });
            }
        }
    }

    controlPanelTemplate(rowData) {
        let optionsLabels = getContextMenu(rowData);
        let optionsMenuControlPanel = [];
        optionsLabels.forEach((option) => {
            optionsMenuControlPanel.push({
                label: option,
                action: () => this.handleControlPanelContextMenu('', option),
                isBold: option === "Continuar",
            })
        });
        return (
            <ContextMenu menuOptions={optionsMenuControlPanel}/>
        );
    }

    boldAndColor(rowData, value, column) {
        let color = column === "statusPV" && rowData.isError === 1 ? "red" : 'black';
        let institution = localStorage.getItem('institution');

        if (validateContinue(rowData, institution)) {
            return <span style={{fontWeight: 'bold', color: color}}>{value}</span>;
        } else {
            return <span style={{color: color}}>{value}</span>;
        }
    }

    boldAndColorTextTemplate(rowData, column) {
        return this.boldAndColor(rowData, rowData[column.field], column.field);
    }

    boldAndColorAmountTemplate(rowData, column) {
        return this.boldAndColor(rowData, amount(rowData[column.field], "right"));
    }

    boldAndColorPriceTemplate(rowData, column) {
        return this.boldAndColor(rowData, price(rowData[column.field], "right"));
    }

    boldAndColorNumberTemplate(rowData, column) {
        return this.boldAndColor(rowData, numberWithComma(rowData[column.field], "right"));
    }

    boldAndColorRateTemplate(rowData, column) {
        return this.boldAndColor(rowData, rateMultipliedByOneHundred(rowData[column.field], "right"));
    }


    getControlPanelLoan() {
        if (this.state !== undefined && !this.state.isLoadingControlPanel) {
            this.loading(true);
            this.loadingControlPanel(true);
            this.controlPanelService.getControlPanelLoan(
                this.state ? this.state.loanIdFilter : 0,
                this.state ? this.state.catFlowFilter.id : 0,
                this.state ? this.state.catInstitutionLenderFilter.idInstitucion : 0,
                this.state ? this.state.catInstitutionBorrowerFilter.idInstitucion : 0,
                this.state ? this.state.catRentTypeFilter.id : 0,
                this.state ? this.state.concertDate : '',
                this.state ? this.state.maturityDate : '',
            ).then(
                response => {
                    if  (response.length > 0) {
                        this.setState({
                            totalExpiredLoad: response[0].totalExpiredLoad,
                        });
                    } else {
                        this.setState({
                            totalExpiredLoad: 0,
                        });
                    }

                    this.loading(false);
                    this.loadingControlPanel(false);
                    this.setState({
                        loanControlPanel: response,
                        disabledSearchButton: false
                    });
                },
                error => {
                    console.log(error);
                    this.loading(false);
                    this.loadingControlPanel(false);
                }
            );
        }
    }

    anticipatedMaturity() {
        this.loading(true);
        this.controlPanelService.anticipatedMaturity(this.state.anticipatedMaturity)
            .then(response => this.getControlPanelLoan());
    }

    clearFilters() {
        this.setState({
            loanIdFilter: '',
            catFlowFilter: [],
            catInstitutionLenderFilter: [],
            catInstitutionBorrowerFilter: [],
            catRentTypeFilter: [],
            maturityDate: '',
            concertDate: '',
        });

        localStorage.removeItem('loanIdFilter');
        localStorage.removeItem('catFlowFilter');
        localStorage.removeItem('catInstitutionLenderFilter');
        localStorage.removeItem('catInstitutionBorrowerFilter');
        localStorage.removeItem('catRentTypeFilter');
        localStorage.removeItem('maturityDate');
        localStorage.removeItem('concertDate');

    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.anticipatedMaturityConfMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                                               invisible={true}
                                                               legend="¿Desea vencer anticipadamente?"
                                                               action={this.anticipatedMaturity}/>;

        return <ControlPanel
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            loading={this.loading}
            anticipatedMaturityConfMsg={this.anticipatedMaturityConfMsg}
            controlPanelTemplate={this.controlPanelTemplate}
            getControlPanelLoan={this.getControlPanelLoan}
            onRowDoubleClickControlPanel={this.onRowDoubleClickControlPanel}
            saveFilters={this.saveFilters}
            loanControlPanel={this.state.loanControlPanel}
            selectRowControlPanel={this.selectRowControlPanel}
            selectedControlPanel={this.state.selectedControlPanel}
            loanIdFilter={this.state.loanIdFilter}
            catFlowFilter={this.state.catFlowFilter}
            catInstitutionLenderFilter={this.state.catInstitutionLenderFilter}
            catInstitutionBorrowerFilter={this.state.catInstitutionBorrowerFilter}
            catRentTypeFilter={this.state.catRentTypeFilter}
            boldAndColorTextTemplate={this.boldAndColorTextTemplate}
            boldAndColorAmountTemplate={this.boldAndColorAmountTemplate}
            boldAndColorPriceTemplate={this.boldAndColorPriceTemplate}
            boldAndColorNumberTemplate={this.boldAndColorNumberTemplate}
            boldAndColorRateTemplate={this.boldAndColorRateTemplate}
            clearFilters={this.clearFilters}
            controlPanelTable={this.controlPanelTable}
            exportOptionsVig={this.state.exportOptionsVig}
            exportOptionsVen={this.state.exportOptionsVen}
            today={this.state.today}
            maturityDate={this.state.maturityDate}
            concertDate={this.state.concertDate}
            totalExpiredLoad={this.state.totalExpiredLoad}
            isAdminUser={this.state.isAdminUser}
        />
    }
};